import { useQuery, useQueryClient } from "@tanstack/react-query"
import { completionTaskName, completionTaskQuery } from "./completion-task.lib"

export function CompletionTaskName({
  conversationId,
}: {
  conversationId: string
}) {
  const queryClient = useQueryClient()
  const { data } = useQuery(completionTaskQuery(conversationId, queryClient))
  const name = data ?? completionTaskName(conversationId)
  return (
    <div className="line-clamp-2 break-all text-xs text-gray-500" title={name}>
      {name}
    </div>
  )
}
